/**
 * Shared frame for sidebar route icons: 24x24 viewBox rendered at 20px,
 * 2px round stroke in `currentColor`. Decorative; the nav label names the item.
 *
 * @param {object} props
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children SVG shapes drawn on the 24x24 grid
 */
export default function NavIcon({ className, children }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      {children}
    </svg>
  );
}
